/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getDriverList: (params) => {
    return axios.get(API_ENDPOINTS.GET_DRIVER_USER, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
  getDriverDetailsById: (id) => {
    let url = API_ENDPOINTS.DRIVER_ENDPOINT + "/" + id;
    return axios.get(url, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  getdriverEarningList: (params) => {
    return axios.get(API_ENDPOINTS.GET_ALL_DRIVER_EARNINGS_LIST, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
  getdriverEarning: (params) => {
    return axios.get(API_ENDPOINTS.GET_A_DRIVER_EARNINGS_LIST, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
  getdriverRewardsList: (params) => {
  return axios.get(API_ENDPOINTS.GET_ALL_DRIVER_REWARDS_LIST, {
    headers: { isAuthRequired: true, "Content-Type": "application/json" },
    params,
  });
  },
  getdriverRewardlogs: (params) => {
    return axios.get(API_ENDPOINTS.GET_A_DRIVER_REWARDS_LIST, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
   getdriverscashoutrecords: (params) => {
    return axios.get(API_ENDPOINTS.GET_A_DRIVERS_CASHOUTRECORDS, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
updatedrivercashoutstatus: (id, data) => {
  let url = API_ENDPOINTS.UPDATE_A_DRIVERS_CASHOUTRECORDS + "/" + id;
  return axios.put(url, data, {
    headers: {
      isAuthRequired: true,
      "Content-Type": "application/json",
    },
  });
},

   getdriverscashoutsheets: (params) => {
    return axios.get(API_ENDPOINTS.GET_A_DRIVERS_CASHOUTSHEETS, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
updatedrivercashoutsheets: (id, data) => {
  let url = API_ENDPOINTS.UPDATE_A_DRIVERS_CASHOUTSHEETS + "/" + id;
  return axios.put(url, data, {
    headers: {
      isAuthRequired: true,
      "Content-Type": "application/json",
    },
  });
},

  addDriver: (data) => {
    return axios.post(API_ENDPOINTS.ADD_DRIVER, data, {
      headers: { isAuthRequired: true, "Content-Type": "multipart/form-data" },
    });
  },
  updateDriver: (id, data) => {
    let url = API_ENDPOINTS.UPDATE_DRIVER + "/" + id;
    return axios.put(url, data, {
      headers: { isAuthRequired: true, "Content-Type": "multipart/form-data" },
    });
  },
      getDriverbankDetailsById: (id) => {
    let url = API_ENDPOINTS.GET_DRIVER_BANK_DETAILS_BY_ID + "/" + id;
    return axios.get(url, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
    updateDriverbankdetails: (id, data) => {
    let url = API_ENDPOINTS.UPDATE_DRIVER_BANK_DETAILS_BY_ID + "/" + id;
    return axios.post(url, data, {
     headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  updateDriverRide: (data) => {
    return axios.put(API_ENDPOINTS.UPDATE_DRIVER_RIDE, data, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  createDriverRide: (data) => {
    return axios.post(API_ENDPOINTS.CREATE_DRIVER_RIDE, data, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  getDriverServiceDetails: (id) => {
    let url = `${API_ENDPOINTS.GET_DRIVER_SERVICE_DETAILS}` + "/" + id;
    return axios.get(url, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
      },
    });
  },
  getDriverDocumentsByDriverId: (id) => {
    let url = `${API_ENDPOINTS.GET_DRIVER_DOCUMENTS_BY_DRIVER_ID}` + "/" + id;
    return axios.get(url, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
      },
    });
  },
  updateDriverDocument: (data) => {
    let url = `${API_ENDPOINTS.UPDATE_DRIVER_DOCUMENT_END_POINT}`;
    return axios.put(url, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "multipart/form-data",
      },
    });
  },
  deleteDriverDocument: (data) => {
    let url = `${API_ENDPOINTS.DELETE_DRIVER_DOCUMENT_END_POINT}`;
    return axios.request({
      method: "delete",
      url: url,
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json", // Use JSON for the body
      },
      data: data, // Pass the `document_id` in the request body
    });
  },
  createDriverDocuments: (data) => {
    let url = `${API_ENDPOINTS.DRIVER_DOCUMENT_END_POINT}`;
    return axios.post(url, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
      },
    });
  },
  updateDriverDocumentStatus: (driverId, documentId, data) => {
    let url =
      `${API_ENDPOINTS.DRIVER_DOCUMENT_UPDATE}` +
      "/" +
      driverId +
      "/" +
      documentId;
    return axios.put(url, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
      },
    });
  },
  getDriverCompleteDetailsByDId: (driverId) => {
    let url = `${API_ENDPOINTS.DRIVER_COMPLETE_DETAILS}` + "/" + driverId;
    return axios.get(url, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
      },
    });
  },
  updateDriverServiceStatus: (driverId, data) => {
    let url = `${API_ENDPOINTS.UPDATE_DRIVER_SERVICE_STATUS}` + "/" + driverId;
    return axios.put(url, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
      },
    });
  },
};
